import React, { useEffect, useState } from 'react';
import useHttp from '../../../hooks/use-http';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { isFormValid } from './validation/isFormValid';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { urls } from './api/urls';

const INITIAL_VALUES = {
  id: 0,
  idTipaMasine: 0,
  naziv: '',
  opis: '',
  nazivTipaMasine: '',
  idKorProm: +localStorage.idKorisnika,
};

const KarakteristikeMasina = ({ save, handleSave, novi, handleNovi }) => {
  const { t, i18n } = useTranslation();
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const { sendRequest: vratiMasine, data: masineData } = useHttp('');
  const { sendRequest: vratiKarakteristike, data: karakteristikeData } =
    useHttp('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  useEffect(() => {
    const configMasine = {
      url: urls.GET_MASINE_COMBO,
      method: 'POST',
      data: { metadata: i18n.language },
    };
    vratiMasine(configMasine);
  }, []);

  const vratiKarakteristikeMasina = () => {
    const configMasine = {
      url: urls.GET_KARAKTERISTIKE_MASINA,
    };
    vratiKarakteristike(configMasine);
  };
  useEffect(() => {
    vratiKarakteristikeMasina();
  }, []);

  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValues({ ...INITIAL_VALUES, id: id });
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_KARKTERISTIKA,
      data: {
        id: formValues.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiKarakteristikeMasina();
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleEditData = async (item) => {
    setFormValues(item);
  };
  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url:
        formValues.id !== 0
          ? urls.IZMENA_KARKTERISTIKA
          : urls.UNOS_KARKTERISTIKA,
      data: formValues,
    };
    const result = await getData(config);
    if (result.id > 0) {
      vratiKarakteristikeMasina();
      setFormValues(INITIAL_VALUES);
      toast.success(
        formValues.id === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  useEffect(() => {
    if (novi) {
      setFormValues(INITIAL_VALUES);
      handleNovi(false);
    }
  }, [novi]);
  return (
    <div>
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        masine={masineData}
      />
      <GridProvider
        data={karakteristikeData}
        handleEditData={handleEditData}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KarakteristikeMasina;
